import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NightShelterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"night_shelter"}/>
}
